module.exports = __webpack_public_path__ + "img/Dantam Makeover 18.20be138a.jpg";